import { render, staticRenderFns } from "./createPedidos.vue?vue&type=template&id=71e98a68&"
import script from "./createPedidos.vue?vue&type=script&lang=js&"
export * from "./createPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports